/**
 * FJ Home tabs/chips switcher for section "fj-bestsellers-chips"
 * Robust: event delegation, aria, default active, works in theme editor.
 *
 * Forventet markup:
 * - Wrapper: .fj-bestsellers
 * - Buttons: button.fj-chip[data-fj-tab="panel-id"] (type="button")
 * - Panels:  .fj-tab-panel[data-fj-panel="panel-id"]
 */
(function () {
  function init(root) {
    const scopes = (root || document).querySelectorAll('.fj-bestsellers');
    scopes.forEach((scope) => {
      const btns = Array.from(scope.querySelectorAll('button.fj-chip[data-fj-tab]'));
      const panels = Array.from(scope.querySelectorAll('[data-fj-panel]'));
      if (!btns.length || !panels.length) return;

      // Ensure buttons are proper buttons
      btns.forEach((b) => {
        if (!b.getAttribute('type')) b.setAttribute('type', 'button');
        b.setAttribute('role', 'tab');
      });

      function setActive(panelId) {
        btns.forEach((b) => {
          const active = b.dataset.fjTab === panelId;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-selected', active ? 'true' : 'false');
          b.setAttribute('aria-pressed', active ? 'true' : 'false');
          b.tabIndex = active ? 0 : -1;
        });

        panels.forEach((p) => {
          const active = p.dataset.fjPanel === panelId;
          p.classList.toggle('is-active', active);
          p.hidden = !active;
        });

        // Remember per-section in session (nice UX)
        const sid = scope.dataset.sectionId || scope.id || '';
        try { sessionStorage.setItem('fj_bestsellers_tab_' + sid, panelId); } catch (e) {}
      }

      // Pick initial tab
      const sid = scope.dataset.sectionId || scope.id || '';
      let saved = null;
      try { saved = sessionStorage.getItem('fj_bestsellers_tab_' + sid); } catch (e) {}
      const firstId = (btns[0] && btns[0].dataset.fjTab) || null;
      const initial = (saved && btns.some(b => b.dataset.fjTab === saved)) ? saved : firstId;
      if (initial) setActive(initial);

      // Click handling (delegation)
      scope.addEventListener('click', (e) => {
        const btn = e.target.closest('button.fj-chip[data-fj-tab]');
        if (!btn || !scope.contains(btn)) return;
        e.preventDefault();
        setActive(btn.dataset.fjTab);
      });

      // Keyboard: arrows between chips
      scope.addEventListener('keydown', (e) => {
        const btn = e.target.closest('button.fj-chip[data-fj-tab]');
        if (!btn || !scope.contains(btn)) return;
        const idx = btns.indexOf(btn);
        if (idx < 0) return;

        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          const next = e.key === 'ArrowRight' ? (idx + 1) % btns.length : (idx - 1 + btns.length) % btns.length;
          btns[next].focus();
          setActive(btns[next].dataset.fjTab);
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => init(document));

  // Shopify Theme Editor live reload hooks
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:section:select', (e) => init(e.target));
})();
